/* eslint-disable indent */
const Urls = {
  DOMAIN_EMAPP:
    process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'staging'
      ? 'http://mobiletest.emoney.cn/emapp'
      : 'https://emapp.emoney.cn',
  DOMAIN_APPSTATIC:
    process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'staging'
      ? 'http://mobiletest.emoney.cn/appstatic'
      : 'https://appstatic.emoney.cn',
  DOMAIN_YKT:
    process.env.VUE_APP_ENV === 'test'
      ? 'https://mobilelan.emoney.cn/yktapi'
      : process.env.VUE_APP_ENV === 'staging'
        ? 'https://yktpre.emoney.cn/yktapi'
        : 'https://yktapi.emoney.cn/'
}

export default Urls
